<template>
  <div class='joinACall'>
    <div class='JACBody'>
      <label class="sub dialTo">
        <span v-if='!calling'>Your Number</span>
        <span v-else>Calling</span>
      </label>

      <div class='JACInputs'>
        <input name="direct-phone" :class='{error: (!this.validNumber && this.enteredNumber)}' v-model='JACPhone' class="overgray" type="text" maxlength="10">

        <sliderTemplate class="slider" :disabled="this.calling" buttonNumber="3" :thirdButtonActive="true ? this.call.inbound : !this.call.inbound">
          <button :class="{ active: option === 'listen'}" @click='selectListen()' slot="firstButton"> LISTEN </button>
          <button :class="{ active: option === 'join'}" @click='seclectJoin()' slot="secondButton"> JOIN </button>
          <button :class="{ active: option === 'coach'}" @click='selectCoach()' v-if='this.call.inbound' slot="thirdButton">COACH</button>
        </sliderTemplate>
      </div>

      <div class='instructions' :class="{invalid: this.calling}">
        <div>We will call you at the number above.</div>
        <div class='instructionsText'>{{instructionsText}}</div>
      </div>

      <loadingGif v-if="this.calling" optionalClass="joinACallLoading">
      </loadingGif>

      <button class="green start"  v-else @click='phoneValidation(); startCall()'>
        <i class="zmdi zmdi-circle liveCircle"></i> Start
      </button>
    </div>

    <!-- Join a call live popup -->
    <article class='popupBG'  v-if='this.stepTwo && !calling'>
      <div class='popup joinCall'>
        <div class='noHeader'>
          <div class='close'  @click='closePop()'></div>
        </div>

        <div class='content'>
          <label>PRESS <div class="numberBox">6</div> ON YOUR PHONE TO JOIN THE CALL.</label>

          <label v-if='!this.call.inbound'>OUTBOUND CALL: <div class="numberBox">5</div> TO COACH WILL ALLOW THE CUSTOMER TO HEAR AND NOT THE AGENT <br> (NOT RECOMMENDED).</label>
         
          <label v-else>PRESS <div class="numberBox">5</div> TO SPEAK TO THE AGENT ONLY.</label>
        </div>
      </div>

      <div class='popupCloseWrap' @click='closePop()'></div>
    </article>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import sliderTemplate from '@/components/slider.vue'
import loadingGif from '@/components/loadingGif.vue'
require('../assets/css/joinACall.css')

export default {
  name: 'joinACallWidget',
  props: ['liveEnabled', 'messageindex', 'callid', 'JACmobile'],
  components:{
    sliderTemplate,
    loadingGif
  },
  computed: {
    ...mapState({
      calling: state => state.calling,
      user: state => state.user,
      call (state) {
        return state.currentMessages[this.messageindex]
      }
    }),
  },
  data: function () {
    return {
      JACPhone: '',
      instructionsText: 'You can listen in, but no one will be able to hear you.',
      option: 'listen',
      stepTwo: false,
      validNumber: false,
      enteredNumber: false
    }
  },
  mounted: function() {
    if (this.user.Phonecode && this.user.Phonecode.phone) {
      this.JACPhone = this.user.Phonecode.phone;
    }
  },
  methods: {
    closePop: function () {
      this.stepTwo = false
    },
    selectCoach: function () {
      this.option = 'coach'
      this.instructionsText = 'The agent will be able to hear you as soon as you pick up the call, but the caller will not hear what you say.'
    },
    selectListen: function () {
      this.option = 'listen'
      this.instructionsText = 'You can listen in, but no one will be able to hear you.'
    },
    seclectJoin: function () {
      this.option = 'join'
      this.instructionsText = 'The caller and agent will be able to hear you as soon as you pick up the phone.'
    },
    startCall: function () {
      if (this.validNumber) {
        if (this.option === 'join') {
          this.$store.dispatch({
            type: 'joinACall',
            callid: this.call.callid,
            phoneNumber: this.JACPhone,
            joinType: 'Join',
            nodeIp: this.call.nodeIP
          })
        }
        else if (this.option === 'coach') {
          this.$store.dispatch({
            type: 'joinACall',
            callid: this.call.callid,
            phoneNumber: this.JACPhone,
            joinType: 'Coach',
            nodeIp: this.call.nodeIP
          })
        }
        else if (this.option === 'listen') {
          this.$store.dispatch({
            type: 'joinACall',
            callid: this.call.callid,
            phoneNumber: this.JACPhone,
            joinType: 'Listen',
            nodeIp: this.call.nodeIP
          })
        }
        this.stepTwo = true;
      }
    },
    phoneValidation: function () {
        this.validNumber = false
        this.enteredNumber = true
        if (!isNaN(this.JACPhone) && (this.JACPhone.length > 9)) {
          this.validNumber = true
        }

    }
  }
}
</script>